import { Button, Container, Section } from "../styles";
import { Header } from './header';
import { GalleryComponent } from './gallery';
import { DynamicButton } from '../shared';

export const Home = () => {
    return (
        <Container>
            <Header />
            <Section>
                <DynamicButton
                    href="https://www.etsy.com/shop/BeadsByJillShop"
                    target="_blank"
                    rel="noopener"
                    buttonType="etsy"
                >
                    My Etsy Shop
                </DynamicButton>
                <DynamicButton
                    href="https://www.instagram.com/beadsbyjill/"
                    target="_blank"
                    rel="noopener"
                    buttonType="instagram"
                >
                    My Instagram
                </DynamicButton>
            </Section>
            <GalleryComponent/>
            <Section>
                <Button href="/about">
                    About
                </Button>
            </Section>
        </Container>
    );
}